import { FC, PropsWithChildren } from "react";
import { useFloating } from "@floating-ui/react";
import IconMenu from "@/assets/imgs/svg/icon_menu.svg";
import useDevice from "@/hooks/useDevice";
import IconButton from "@/components/IconButton";

interface Props {
  isOpen: boolean;
  openHandler: () => void;
  closeHandler: () => void;
}

const MenuNavigation: FC<PropsWithChildren<Props>> = ({
  isOpen,
  openHandler,
  closeHandler,
  children,
}): JSX.Element => {
  const { isPc } = useDevice();
  const { refs, floatingStyles } = useFloating({
    placement: isPc ? "bottom-start" : "bottom-end",
  });

  return (
    <>
      <IconButton
        ref={refs.setReference}
        aria-label="チームの機能一覧"
        onClick={isOpen ? closeHandler : openHandler}
        variant="secondary"
        size="large"
      >
        <IconMenu />
      </IconButton>
      {isOpen && (
        <div
          ref={refs.setFloating}
          style={floatingStyles}
          className="shadow-default rounded-xs overflow-hidden"
        >
          {children}
        </div>
      )}
    </>
  );
};

export default MenuNavigation;
